// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../node_modules/postcss-loader/dist/cjs.js!../style/theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.screen_V6orL {
  position:absolute;
  top:0;
  left:0;
  right:0;
  bottom:0;
  display:flex;
  flex-direction:column;
}

.header_XAJqd {
  position:relative;
  padding:10px 20px;
  align-items: center;
}

.content_m_CmS {
  flex:1;
  position:relative;
  overflow:auto;
}

.footer_ZntVD {
  position:relative;
  padding:10px;
}`, "",{"version":3,"sources":["webpack://./src/views/screen.css"],"names":[],"mappings":"AAEA;EACE,iBAAiB;EACjB,KAAK;EACL,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,MAAM;EACN,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd","sourcesContent":["@import \"../style/theme.css\";\n\n.screen {\n  position:absolute;\n  top:0;\n  left:0;\n  right:0;\n  bottom:0;\n  display:flex;\n  flex-direction:column;\n}\n\n.header {\n  position:relative;\n  padding:10px 20px;\n  align-items: center;\n}\n\n.content {\n  flex:1;\n  position:relative;\n  overflow:auto;\n}\n\n.footer {\n  position:relative;\n  padding:10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"screen": `screen_V6orL`,
	"header": `header_XAJqd`,
	"content": `content_m_CmS`,
	"footer": `footer_ZntVD`
};
export default ___CSS_LOADER_EXPORT___;
